
// Configuración de caché
export const CACHE_DURATION_MS = 30 * 60 * 1000; // 30 minutos
export const CACHE_CLEANUP_INTERVAL_MS = 5 * 60 * 1000; // 5 minutos

// Configuración de timeouts
export const FETCH_TIMEOUT_MS = 15 * 1000; // 15 segundos
export const ICAL_FETCH_TIMEOUT_MS = 10 * 1000; // 10 segundos

// Breakpoints responsive
export const BREAKPOINTS = {
  mobile: 768,
  tablet: 1024,
  desktop: 1280,
} as const;

// Configuración de precios
export const CLEANING_FEE = 350;
export const DEFAULT_PRICE_PER_NIGHT = 1000;

// Configuración de huéspedes
export const DEFAULT_GUEST_COUNT = 2;
export const MIN_GUEST_COUNT = 1;
export const MAX_GUEST_COUNT = 16;

// Configuración de fechas
export const DEFAULT_STAY_NIGHTS = 1;
export const MIN_STAY_NIGHTS = 1;
export const MAX_ADVANCE_BOOKING_DAYS = 365;

// URLs y endpoints
export const CORS_PROXY_URL = 'https://api.allorigins.win/raw?url=';

// Configuración de viewport
export const MOBILE_BOOKING_BAR_HEIGHT = 80;
export const NAVBAR_HEIGHT = 64;

// Mensajes de error comunes
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Error de conexión. Verifica tu internet.',
  CALENDAR_LOAD_ERROR: 'Error al cargar el calendario',
  DATE_PARSE_ERROR: 'Error al procesar las fechas',
  PROPERTY_NOT_FOUND: 'Propiedad no encontrada',
  INVALID_DATES: 'Las fechas seleccionadas no son válidas',
} as const;

// Configuración de animaciones
export const ANIMATION_DURATION = {
  fast: 150,
  normal: 300,
  slow: 500,
} as const;
